import { commonPhotoSwipe } from './common_photo_swipe'
import { commonItemLike } from './common_item_like'

export default function(attributes) {
  const { max_amount_to_choose, items } = attributes;
  return {
    el: '#app',
    data() {
      return {
        mainSliderOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          asNavFor: '.nav-slider',
        },
        navSliderOptions: {
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.main-slider',
          dots: true,
          focusOnSelect: true
        },
        amount: max_amount_to_choose === 0 ? '' : 1,
        items,
      }
    },
    computed: {
      validAmount() {
        return this.amount > 0
      },
      validInput() {
        return (this.validAmount)
      },
    },
    mixins: [commonPhotoSwipe, commonItemLike]
  }
}
